import React from 'react';

const Features = () => {
  return (
    <div className="section">
      <div className="container _4em">
        <div className="grid-6-col">
          <div id="w-node-_9acb6e39-e985-ebce-2ef5-19ba02513fee-f5a0c33c" className="title-container">
            <div className="fade-in-move-on-scroll">
              <h1>Unlock a Suite of Powerful Features Tailored for Forex Analysis.</h1>
            </div>
            <div className="fade-in-move-on-scroll">
              <p className="paragraph-white">Step into a world of clarity and precision with TrenziX&#x27;s robust features designed for the discerning trader. From real-time currency strength indicators to insightful market divergence alerts, our app provides all the essential tools to enhance your trading strategy. Every feature is crafted to offer actionable insights, helping you make decisions with confidence and ease. Discover the power of informed trading – all in one app.</p>
            </div>
          </div>
        </div>
        <div className="feature-grid-holder">
          <div className="w-layout-grid feature-cards">
            <div id="w-node-_80744953-1164-62c7-834a-49586763b7b6-f5a0c33c" className="feature-cards-container">
              <div className="feature-card-paddings">
                <div className="feature-card-big-app-holder">
                  <div className="relative">
                    <div className="fade-in-move-on-scroll">
                      <h4 className="no-margins">Seamlessly Integrated, Native Design</h4>
                    </div>
                    <div className="fade-in-move-on-scroll">
                      <p>Experience unmatched usability with TrenziX&#x27;s native mobile design.</p>
                    </div>
                  </div>
                  <div className="app-gardient-top"></div>
                  <div className="full-app-image-container"><img src="/assets/images/3D_Image_4.png" loading="lazy" alt="" className="full-app-image"/></div>
                </div>
              </div>
            </div>
            <div className="feature-cards-container _02">
              <div className="feature-card-paddings">
                <div className="feature-card-big-app-holder _02">
                  <div className="relative">
                    <div className="fade-in-move-on-scroll">
                      <h4 className="no-margins">Data at Your Fingertips</h4>
                    </div>
                    <div className="fade-in-move-on-scroll">
                      <p></p>
                    </div>
                  </div>
                  <div className="app-gardient-bot"></div>
                  <div className="app-gardient-top"></div>
                  <div className="phone-container">
                    <div className="phone-image-container"><img src="/assets/images/SmartMoneyBarChart.jpg" loading="lazy" sizes="(max-width: 479px) 86vw, (max-width: 767px) 65vw, (max-width: 991px) 63vw, 282px" srcSet="/assets/images/SmartMoneyBarChart-p-500.jpg 500w, /assets/images/SmartMoneyBarChart-p-800.jpg 800w, /assets/images/SmartMoneyBarChart.jpg 1080w" alt="" className="iphone-image"/></div>
                    <div className="iphone-screen-image-container"><img src="/assets/images/Iphone-App-Image.jpg" loading="lazy" sizes="(max-width: 479px) 80vw, (max-width: 991px) 61vw, 254px" srcSet="/assets/images/Iphone-App-Image-p-500.jpeg 500w, /assets/images/Iphone-App-Image.jpg 704w" alt="" className="iphone-screen-image"/></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-layout-grid feature-cards">
            <div id="w-node-_6eda20d0-05fc-a501-ad3d-6ae5e36c303e-f5a0c33c" className="feature-cards-container _02">
              <div className="feature-card-paddings">
                <div className="feature-card-big-app-holder _02">
                  <div className="relative">
                    <div className="fade-in-move-on-scroll">
                      <h4 className="no-margins">Instant Insights</h4>
                    </div>
                    <div className="fade-in-move-on-scroll">
                      <p></p>
                    </div>
                  </div>
                  <div className="app-gardient-bot"></div>
                  <div className="app-gardient-top"></div>
                  <div className="phone-container _02">
                    <div className="phone-image-container"><img src="/assets/images/GoldBarChart.jpg" loading="lazy" sizes="(max-width: 991px) 100vw, 394.796875px" srcSet="/assets/images/GoldBarChart-p-500.jpg 500w, /assets/images/GoldBarChart-p-800.jpg 800w, /assets/images/GoldBarChart.jpg 1080w" alt="" className="iphone-image"/></div>
                    <div className="iphone-screen-image-container"><img src="/assets/images/Iphone-App-Image.jpg" loading="lazy" sizes="(max-width: 479px) 97vw, (max-width: 991px) 100vw, 366.796875px" srcSet="/assets/images/Iphone-App-Image-p-500.jpeg 500w, /assets/images/Iphone-App-Image.jpg 704w" alt="" className="iphone-screen-image"/></div>
                  </div>
                </div>
              </div>
            </div>
            <div id="w-node-_6eda20d0-05fc-a501-ad3d-6ae5e36c3031-f5a0c33c" className="feature-cards-container">
              <div className="feature-card-paddings">
                <div className="feature-card-big-app-holder">
                  <div className="relative">
                    <div className="fade-in-move-on-scroll">
                      <h4 className="no-margins">Never Miss a Beat</h4>
                    </div>
                    <div className="fade-in-move-on-scroll">
                      <p>Stay ahead of the market with TrenziX’s detailed alert system. Our platform ensures you’re always informed with real-time notifications on significant market movements and trend changes. </p>
                    </div>
                  </div>
                  <div className="full-app-image-container _02"><img src="/assets/images/3D_Image_7.png" loading="lazy" alt="" className="full-app-image"/></div>
                  <div className="app-gardient-bot"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
